module.exports = __webpack_public_path__ + "static/media/heart-sign.bc8148c7.svg";